export const analyticsConfig = {
  loadAnalytics: import.meta.env.PROD,
  segmentWriteKey: '7I98l8ZPw7qpepSWQ5DH9wuswrgH2kyE',
  mixpanelProjectToken: '247e1d8eb207cf46f9fac08b9c34cdc0',
  groupKey: 'organization_id',
};
